import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserModel } from 'shared';

@Injectable()
export class ProfileService {
  constructor(private http: HttpClient) {
  }

  public loadCurrentUser(): Observable<UserModel> {
    return this.http.get<UserModel>('/api/user/current-user/');
  }

  public updateUser(user: Partial<UserModel>): Observable<UserModel> {
    const data = new FormData();

    if (user.avatar) {
      data.append('avatar', user.avatar, user.avatar.name);
    }

    return this.http.patch<UserModel>('/api/user/', data);
  }
}
